import ImmoHeader from "../../immobilier/componnents/ImmoHeader";
import { useDispatch, useSelector } from "react-redux";
import { setActiveView } from "../../../redux/actions/immobilierActions";
import ListeLotsEnregistres from "./ListeLotsEnregistres";
import ListeProgrammesEnregistres from "./ListeProgrammesEnregistres";
import {
  setEnregistresActiveOnglet,
  setEnregistresSingleProgramId,
  addEnregistresOpenLot,
  fetchEnregistresSingleLot,
} from "../../../redux/actions/enregistresActions";
import { useState } from "react";

const FavorisListe = () => {
  const { activeView } = useSelector((state) => state.immobilierReducer);
  const dispatch = useDispatch();

  const { user } = useSelector((state) => state.userAuthReducer);

  const handleProgramClick = (programId) => {
    dispatch(setEnregistresSingleProgramId(programId));
    dispatch(setEnregistresActiveOnglet("programme"));
  };

  const handleLotClick = (lotId) => {
    dispatch(addEnregistresOpenLot(lotId));
    dispatch(fetchEnregistresSingleLot(lotId));
    dispatch(setEnregistresActiveOnglet(`lot-${lotId}`));
  };
  const [lotsFilter, setLotsFilter] = useState("");
  const filteredLots = user?.lots_favoris.filter((lot) => {
    return lot?.reference?.toLowerCase().includes(lotsFilter?.toLowerCase());
  });

  const filteredPrograms = user?.programmes_favoris.filter((program) => {
    return program?.name?.toLowerCase().includes(lotsFilter?.toLowerCase());
  });
  return (
    <div>
      <ImmoHeader
        activeView={activeView}
        setActiveView={(view) => dispatch(setActiveView(view))}
        carte={false}
        filterInput={lotsFilter}
        setFilterInput={setLotsFilter}
        filterBtn={false}
      />
      {activeView === "lots" ? (
        <>
          <ListeLotsEnregistres
            lotsFavoris={filteredLots}
            onLotClick={handleLotClick}
            filterInput={lotsFilter}
            setFilterInput={setLotsFilter}
          />
        </>
      ) : null}
      {activeView === "programmes" ? (
        <>
          <ListeProgrammesEnregistres
            programmesFavoris={filteredPrograms}
            onProgramClick={handleProgramClick}
            filterInput={lotsFilter}
            setFilterInput={setLotsFilter}
          />
        </>
      ) : null}
    </div>
  );
};

export default FavorisListe;
